/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Brand_Kit_InvalidInputs */

const en_error_brand_kit_invalid = /** @type {(inputs: Error_Brand_Kit_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The brand kit cannot be saved like this: check the fields marked.`)
};

/**
* | output |
* | --- |
* | "The brand kit cannot be saved like this: check the fields marked." |
*
* @param {Error_Brand_Kit_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_brand_kit_invalid = /** @type {((inputs?: Error_Brand_Kit_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Brand_Kit_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_brand_kit_invalid(inputs)
});